import React from "react";
import Hamburger from "components/hamburger-menu";
import Image from "components/image";
import MobileHeaderData from "./data";
import Search from "components/search";
import ShoppingCart from "components/shopping-cart";
import { ReactComponent as Heart } from "svgs/fi-rs-heart.svg";
import { ReactComponent as User } from "svgs/fi-rs-user.svg";
import Link from "components/link";
import { useSettings, useCustomer } from "hooks/useStore";
import { ReactComponent as SearchIcon } from "svgs/fi-rs-search.svg";
import clsx from "clsx/lite";

const MobileHeader = ({ data, searchData, embedHeader, variation2 }) => {
	const { toggleMenu, isMenuOpen, isSearchOpen } = useSettings(["toggleMenu", "isMenuOpen", "isSearchOpen"]);
	const { isAuthenticated } = useCustomer(["isAuthenticated"]);
	const { logo, links } = data;
	const { social, contactInfo } = data.settings;

	return (
		<header className={clsx("mobile-header", variation2 ? "variation_2" : "variation_1", embedHeader && "bg-transparent")}>
			<nav className={clsx("flex items-center px-4 py-2",
				!isMenuOpen && !embedHeader && "border-b", isSearchOpen && "nav-t59"
			)}>
				<div className="w-1/3 flex justify-start items-center gap-3.5 md:justify-start">
					<Hamburger isOpen={isMenuOpen} toggle={toggleMenu} embedHeader={embedHeader} />
					{!isMenuOpen &&
						<button onClick={toggleMenu} className={clsx("flex md:hidden t-search-icon", embedHeader && "invert")}>
							<SearchIcon />
						</button>
					}
				</div>
				<div className="w-1/3 flex justify-center">
					<Image image={logo} className={clsx("w-20", embedHeader && "invert")}
						onClick={() => toggleMenu(false)} onFocus={() => toggleMenu(false)} />
				</div>
				<div className="w-1/3	flex gap-4 justify-end items-center md:justify-end">
					<div className="hidden md:flex gap-4">
						<Search data={searchData} embedHeader={embedHeader} logo={logo} />
						<Link to={`/account/${isAuthenticated ? "orders" : "login"}`}>
							<User className={clsx(embedHeader && "invert")} />
						</Link>
					</div>
					<Link to="/wishlist" onClick={() => isMenuOpen && toggleMenu()}>
						<Heart className={clsx("fill-black size-5", embedHeader && "invert")} />
					</Link>
					<div className="flex sm:hidden">
						<ShoppingCart embedHeader={embedHeader} />
					</div>
					<div className="hidden sm:flex">
						<ShoppingCart redirectToCartPage embedHeader={embedHeader} />
					</div>
				</div>
			</nav>
			<MobileHeaderData settings={{ social, contactInfo }} data={links}
				isOpen={isMenuOpen} toggle={toggleMenu} searchData={searchData} />
		</header>
	);
};

export default MobileHeader;